import { render, staticRenderFns } from "./AccountInfocardForm.vue?vue&type=template&id=11fbfac2&"
import script from "./AccountInfocardForm.vue?vue&type=script&lang=js&"
export * from "./AccountInfocardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports